import {
  Datagrid,
  TextField,
  useTranslate,
  FunctionField,
  EditButton,
  useRecordContext,
} from "react-admin";
import { useNavigate } from "react-router";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  CreateOnlyTopToolbar,
  CustomList,
} from "../../shared/components/index.js";
import { Button } from "@mui/material/index.js";
import SendIcon from "@mui/icons-material/Send";
import { useTheme } from "@mui/material/styles/index.js";

const SendNotification = () => {
  const t = useTranslate();
  const record = useRecordContext();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  record &&
    record.status === "active" &&
    localStorage.setItem("pushNotificationServiceId", record.id);

  return (
    <Button
      className="button-edit-push"
      onClick={(e) => {
        e.stopPropagation();
        return navigate(`/PushNotificationService/${record.id}/send`);
      }}
      disabled={record?.status !== "active"}
      sx={{
        color: isDarkMode ? "#ffffff" : "#291680",
      }}
    >
      <SendIcon
        fontSize="small"
        sx={{
          color:
            record?.status === "active"
              ? isDarkMode
                ? "#ffffff"
                : "#291680"
              : "#808080",
        }}
      />
      <p
        style={{
          marginLeft: "8%",
          fontSize: "small",
          color:
            record?.status === "active"
              ? isDarkMode
                ? "#ffffff"
                : "#291680"
              : "#808080",
        }}
      >
        {t("resources.PushNotificationService.source.send")}
      </p>
    </Button>
  );
};

const listPushNotificationServices = () => {
  const t = useTranslate();

  return (
    <CustomList actions={<CreateOnlyTopToolbar />}>
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <TextField source="name" />
        <div className="config-json">
          <JsonField
            className="config-json"
            label="resources.PushNotificationService.fields.config.name"
            source="config"
            reactJsonOptions={{
              name: null,
              collapsed: true,
              enableClipboard: false,
              displayDataTypes: false,
            }}
            sortable={false}
          />
        </div>
        <FunctionField
          source="status"
          render={(record) =>
            t(
              `resources.PushNotificationService.source.status.${record.status}`
            )
          }
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <EditButton className="button-edit" />
        <SendNotification />
      </Datagrid>
    </CustomList>
  );
};

export default listPushNotificationServices;
